export const declarationsTr = {
  title: 'Beyanlar ve alerjenler',
  subtitle:
    'Onaylı reçetelerden kontrollü hukuki incelemeyle oluşturulan çok dilli, sürümlü öneriler.',
  help: 'Beyanlar, terim kataloğu ve onaylar için yardımı aç',
  empty: 'Seçilen filtrelere uygun beyan sürümü yok.',
  pagination: 'Sayfa {{page}} / {{pages}} · {{total}} sürüm',
  actions: {
    catalog: 'Alan kataloğu',
    generate: 'Öneri oluştur',
    newTerm: 'Katalog girdisi',
    submit: 'İncelemeye gönder',
    review: 'İncelemeyi tamamla',
    approve: 'Onayla',
    publish: 'Yayımla',
    archive: 'Arşivle',
    copy: 'Yeni sürüm',
    override: 'Gerekçeli değiştir',
    confirm: 'Onayla',
    history: 'Sürümler',
  },
  filters: {
    search: 'Numara, ürün, pazar veya terim ara',
    allStatuses: 'Tüm durumlar',
    allTypes: 'Tüm türler',
  },
  statuses: {
    DRAFT: 'Taslak',
    VALIDATION_ERROR: 'Doğrulama hatası',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylandı',
    PUBLISHED: 'Yayımlandı',
    SUPERSEDED: 'Değiştirildi',
    ARCHIVED: 'Arşivlendi',
  },
  catalogStatuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylandı',
    SUPERSEDED: 'Değiştirildi',
    ARCHIVED: 'Arşivlendi',
  },
  allergenStatuses: {
    CONTAINS: 'İçerir',
    MAY_CONTAIN: 'İçerebilir',
    DOES_NOT_CONTAIN: 'İçermez',
    UNKNOWN: 'Bilinmiyor',
  },
  issueSeverity: { ERROR: 'Hata', WARNING: 'Uyarı' },
  types: {
    INGREDIENT: 'Bileşen',
    ALLERGEN: 'Alerjen',
    ADDITIVE: 'Katkı maddesi',
    FUNCTION_CLASS: 'Fonksiyon sınıfı',
    ORIGIN_STATEMENT: 'Menşe bildirimi',
    COLLECTIVE_DESIGNATION: 'Toplu adlandırma',
    WARNING: 'Uyarı',
    CLAIM: 'İddia',
    PRODUCT_DESIGNATION: 'Yasal/ürün adı',
    QUID_RULE: 'QUID kuralı',
  },
  columns: {
    number: 'Numara',
    product: 'Ürün',
    market: 'Pazar',
    version: 'Sürüm',
    status: 'Durum',
    issues: 'Hata / uyarı',
    updated: 'Güncellendi',
    key: 'Anahtar',
    type: 'Tür',
    name: 'Ad',
    validity: 'Geçerlilik',
    path: 'Kaynak / yol',
    weight: 'İlgili ağırlık',
    percentage: 'Pay',
    flags: 'İşaretler',
    field: 'Alan',
    recipe: 'Reçete',
  },
  fields: {
    key: 'Kalıcı anahtar',
    type: 'Alan türü',
    code: 'Kod / E numarası',
    metadata: 'Yapılandırılabilir meta veri (JSON)',
    validFrom: 'Geçerlilik başlangıcı',
    validTo: 'Geçerlilik sonu',
    changeReason: 'Değişiklik nedeni',
    name: 'Ad',
    synonyms: 'Virgülle ayrılmış eş anlamlılar',
    description: 'Açıklama',
    reason: 'İnceleme veya karar notu',
    recipe: 'Onaylı reçete sürümü',
    number: 'Beyan numarası (isteğe bağlı)',
    market: 'Pazar/kural kümesi anahtarı',
    ingredients: 'Bileşen listesi',
    allergens: 'Alerjen bildirimi',
    additives: 'Katkı maddeleri',
    warnings: 'Uyarılar ve menşe',
    productDesignation: 'Yasal/ürün adı',
    ingredientText: 'Bileşen listesi',
    allergenText: 'Alerjen bildirimi',
    additiveText: 'Katkı metni',
    warningText: 'Uyarılar ve menşe',
    overrideReason: 'Elle sapma gerekçesi',
    warningAcknowledgement: 'Kalan tüm uyarıların gerekçeli kabulü',
  },
  catalog: {
    title: 'Yapılandırılabilir beyan kataloğu',
    subtitle:
      'Sürümlü bileşenler, alerjenler, katkılar, fonksiyon sınıfları, kurallar ve dile özgü terimler.',
    empty: 'Katalog sürümü bulunamadı.',
    createTitle: 'Katalog girdisi oluştur',
    editTitle: 'Katalog sürümü v{{version}} düzenle',
    editorHelp:
      'Meta verideki sayılar ondalık metin olarak saklanır. İnceleme öncesinde tüm desteklenen diller tamamlanmalıdır.',
    historyTitle: 'Sürüm geçmişi: {{key}}',
    historyDescription: 'Onaylı terimler değiştirilemez; değişiklikler yeni sürüm oluşturur.',
  },
  generate: {
    title: 'Beyan önerisi oluştur',
    description:
      'Motor onaylı BOM’u, alt reçeteleri ve bileşik bileşenleri tekrarlanabilir biçimde çözümler.',
    legalWarning:
      'Bu otomatik hukuki onay değildir. Sonuç bağımsız uzman incelemesi ve açık yayımlama gerektirir.',
  },
  detail: {
    subtitle: 'Sürüm {{version}} · Pazar {{market}} · Kaynak {{recipe}} v{{recipeVersion}}',
  },
  legal: {
    title: 'Uzman ve hukuki inceleme gerekli',
    description:
      'Hesaplanan öneri, QUID işaretleri, iddialar, uyarılar ve çeviriler hukuken bağlayıcı kullanımdan önce yetkin kişilerce incelenmelidir.',
  },
  summary: {
    status: 'İş akışı durumu',
    ingredients: 'Bileşen kalemleri',
    allergens: 'Alerjen bulguları',
    errors: 'Doğrulama hataları',
    warnings: 'Uyarılar',
  },
  tabs: {
    preview: 'Dil önizleme',
    comparison: 'Dil karşılaştırması',
    sources: 'Kaynaklar ve anlık görüntü',
    validation: 'Doğrulama',
    history: 'Sürüm geçmişi',
  },
  sections: {
    ingredients: 'Ağırlığa göre sıralı bileşenler',
    allergens: 'Türetilen alerjenler',
    additives: 'Katkılar ve fonksiyon sınıfları',
    sourceSnapshot: 'Değiştirilemez kaynak kanıtı',
    validation: 'Doğrulama ve veri kalitesi',
    history: 'Beyan revizyonları',
  },
  preview: {
    ingredientText: 'Bu dil için onaylanacak geçerli metin.',
    sorting: 'Sıra ve yüzdeler beyan ağırlığından kesin ondalık hesapla üretildi.',
    unknownWarning: '“Bilinmiyor” hiçbir zaman “içermez” olarak değerlendirilmez.',
  },
  comparison: {
    title: 'Desteklenen tüm dilleri karşılaştır',
    description: 'Sarı değerler otomatik metinden gerekçeli sapmaları gösterir.',
    automatic: 'Otomatik hesaplanan metni göster',
  },
  sources: {
    description:
      'Somut onaylı sürümler ve özet değer hesaplamayı daha sonra tekrarlanabilir kılar.',
    approvedAt: 'Reçete onay tarihi',
    profiles: 'Malzeme profili sürümleri',
    catalogVersions: 'Katalog sürümleri',
    materialSources: 'Malzeme kaynakları',
  },
  validation: {
    description:
      'Hatalar incelemeyi engeller. Uyarılar onaydan önce açıkça değerlendirilmeli ve kabul edilmelidir.',
  },
  history: {
    description: 'Yayımlanan sürümler eksiksiz anlık görüntüler olarak değişmeden kalır.',
  },
  states: {
    noAllergens: 'Onaylı kaynak verilerinde alerjen bulgusu yok.',
    noAdditives: 'Onaylı kaynak verilerinde katkı maddesi yok.',
    noIssues: 'Doğrulama hatası veya veri kalitesi uyarısı yok.',
    notFound: 'Beyan sürümü bulunamadı.',
  },
  override: {
    title: 'Elle sapmaları belgele',
    description:
      'Otomatik metinler anlık görüntüde kalır. Her değişiklik ortak teknik gerekçeyle sapma olarak kaydedilir.',
  },
  publish: {
    confirmation:
      'Onay, tam olarak bu onaylı ve değiştirilemez anlık görüntüyü yayımlar. Harici hukuki danışmanlığın yerini almaz.',
  },
  actionDialog: {
    APPROVE: {
      title: 'Beyanı onayla',
      description: 'Bağımsız onay bu sürümü dondurur. Kalan uyarılar izlenebilir kabul gerektirir.',
    },
    COPY: {
      title: 'Katalog sürümü oluştur',
      description: 'İçerik yeni, düzenlenebilir taslağa kopyalanır.',
    },
    ARCHIVE: {
      title: 'Sürümü arşivle',
      description: 'Sürüm denetlenebilir kalır ancak yeni kullanımlar için etkin olmaz.',
    },
    REVIEW: {
      title: 'Uzman incelemesini tamamla',
      description:
        'Kaynakların, hesaplamanın, dillerin ve uyarıların bağımsız incelemesini belgeleyin.',
    },
    PUBLISH: {
      title: 'Beyanı açıkça yayımla',
      description: 'Yayımlama, onaydan sonraki ayrı ve hukuken önemli adımdır.',
    },
  },
  messages: {
    generated: 'Beyan önerisi tekrarlanabilir biçimde oluşturuldu.',
    saved: 'Katalog sürümü kaydedildi.',
    overrideSaved: 'Elle sapmalar kaydedildi.',
    submitted: 'Beyan bağımsız incelemeye gönderildi.',
    workflow: 'İş akışı denetim iziyle güncellendi.',
  },
} as const;
